import React, { useContext } from "react";
import { FarfetchProject } from "../components/projects/FarfetchProject";
import { MaxfashionProject } from "../components/projects/MaxfashionProject";
import { PlantsguruProject } from "../components/projects/PlantsguruProject";
import { React_Redux_Cart } from "../components/projects/React_Redux_Cart";
import { ShortURLProject } from "../components/projects/ShortURLProject";
import { ThemeContext } from "../themeProvider";

const Projects = () => {
    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;

    return (
        <div
            id="projects"
            className={ darkMode ? "bg-white text-black" : "bg-gray-900 text-white" }
        >
            <div className="max-w-7xl mx-auto x-4 sm:px-6 lg:px-8 px-4  pt-24 pb-12">
                <h2 className="text-5xl font-bold px-4 md:px-0 text-center">
                    Projects
                </h2>
                <h4 className="mt-16 text-3xl font-semibold text-blue-600">
                    What I Built
                </h4>
                <div className="mt-8 flex justify-between items-stretch flex-wrap md:center">
                    {/* <FarfetchProject /> */}
                    <ShortURLProject  />
                    <React_Redux_Cart />
                    <MaxfashionProject />
                    <PlantsguruProject />
                </div>
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://github.com/Akshay-Singh-Rajput/ProjectsLibrary"
                    className=" w-32 flex items-center py-4 px-4 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 mx-auto mt-4"
                >
                    Show More
                    <svg
                        className="ml-2 -mr-1 w-4 h-4"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                </a>
            </div>
        </div>
    );
};

export default Projects;
